<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1B42McE/tc-custom/9780226818771.jpg?1736424843652" alt="This image is the cover for the book J. M. Coetzee and the Ethics of Reading"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">J. M. Coetzee and the Ethics of Reading
      </h1>
      <p class="bookDescription body article font2">
        <p>Nobel Prize-winning novelist J. M. Coetzee is one of the most widely taught contemporary writers, but also one of the most elusive. Many critics who have addressed his work have devoted themselves to rendering it more accessible and acceptable, often playing down the features that discomfort and perplex his readers.<br/><br/> Yet it is just these features, Derek Attridge argues, that give Coetzee's work its haunting power and offer its greatest rewards. Attridge does justice to this power and these rewards in a study that serves as an introduction for readers new to Coetzee and a stimulus for thought for those who know his work well. Without overlooking the South African dimension of his fiction, Attridge treats Coetzee as a writer who raises questions of central importance to current debates both within literary studies and more widely in the ethical arena. Implicit throughout the book is Attridge's view that literature, more than philosophy, politics, or even religion, does singular justice to our ethical impulses and acts. Attridge follows Coetzee's lead in exploring a number of issues such as interpretation and literary judgment, responsibility to the other, trust and betrayal, artistic commitment, confession, and the problematic idea of truth to the self.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Derek Attridge
      </h2>
      
      <p class="authorDescription body article"><B>Derek Attridge</B> is professor of English at the University of York. He is the author or editor of numerous works, including <I>Peculiar Language, Joyce Effects, Meter and Meaning, Poetic Rhythm</I>, and <I>The Singularity of Literature</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?31cd58f0